import { useMutation } from '@tanstack/react-query'
import { useContext } from 'react'

import { signout } from '@src/api'
import { L_STORAGE_KEYS } from '@src/consts'
import { useCustomSnackbar } from '@src/hooks'
import { queryClient } from '@src/libs'
import { TfaTokenContext } from '@src/pages/_app.page'
import { lStorage, sleep } from '@src/utils'

import { OnSuccessArgs } from '../type'

export const useSignout = () => {
  const { openSnackbar } = useCustomSnackbar()
  const tfaTokenContext = useContext(TfaTokenContext)

  return useMutation({
    mutationFn: signout,
    onError: () => {
      window.location.href = '/signin'
    },
    onSuccess: async (_, { backUrl, isSessionTimeout }: OnSuccessArgs) => {
      lStorage.removeItem(L_STORAGE_KEYS.USER)
      lStorage.removeItem(L_STORAGE_KEYS.TOKEN)
      lStorage.removeItem(L_STORAGE_KEYS.MAIL_ADDRESS)
      lStorage.removeItem(L_STORAGE_KEYS.SMS_PHONE_NUMBER)
      tfaTokenContext?.setTfaToken(null)
      tfaTokenContext?.setTfaTokenExpiresAt(null)
      if (isSessionTimeout) {
        openSnackbar(
          'セッションの有効期限が切れました。\nお手数ですが、再度ログインをお願いします。',
          'error'
        )
        await sleep({})
      }
      window.location.href = backUrl ? `/signin?backUrl=${backUrl}` : '/signin'

      queryClient.invalidateQueries({
        refetchType: 'active',
      })
    },
  })
}
